var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { staticClass: "microportal text-center h-100", class: _vm.cardClasses },
    [
      _c("i", { class: _vm.icon }),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "text-uppercase" },
        [
          _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
          _vm._t("label"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.to
        ? _c("b-link", {
            staticClass: "card-link stretched-link",
            attrs: { to: _vm.to },
          })
        : _vm._e(),
      _vm._v(" "),
      typeof _vm.clickHandler === "function"
        ? _c("a", {
            staticClass: "card-link stretched-link",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.clickHandler.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }